import { render, staticRenderFns } from "./dprodesc.vue?vue&type=template&id=200635bd&scoped=true"
import script from "./dprodesc.vue?vue&type=script&lang=js"
export * from "./dprodesc.vue?vue&type=script&lang=js"
import style0 from "./dprodesc.vue?vue&type=style&index=0&id=200635bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200635bd",
  null
  
)

export default component.exports